import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(data.message);
    } catch (err) {
      setSent("If an account exists for this email, you will receive a password reset link shortly. Check your inbox.");
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center bg-slate-50 px-4 py-12">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm" data-testid="forgot-password-screen">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-primary text-white"><KeyRound className="h-6 w-6" /></div>
          <h1 className="font-heading text-2xl font-bold text-slate-900">Reset your password</h1>
          <p className="text-sm text-slate-500">Enter your email address and we'll send you a link to reset your password.</p>
        </div>
        {sent ? (
          <p data-testid="forgot-success" className="rounded-xl bg-emerald-50 px-4 py-3 text-sm text-emerald-700">{sent}</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1 rounded-lg" placeholder="you@email.com" />
            </div>
            <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full rounded-full bg-primary font-semibold hover:bg-primary/90">
              {loading ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}
        <p className="mt-6 text-center text-sm text-slate-500">
          <Link to="/login" data-testid="back-to-login" className="font-semibold text-primary">Back to login</Link>
        </p>
      </div>
    </div>
  );
}
